import styled from 'styled-components';
import { BaseStyledComponentProps, navBarButtonWrapperStyle, navBarIconStyle, StyleColor } from '../../../../utils/styles-constants';

interface StyledHeaderButtonProps extends BaseStyledComponentProps {
	isActive: boolean;
}

const StyledHeaderButton = styled('div')`
	${navBarButtonWrapperStyle}
	display: flex;
	align-items: center;
	justify-content: center;

	& > svg {
		${navBarIconStyle}
		fill: ${(props: StyledHeaderButtonProps) => props.isActive
			? props.theme.primary.actionColor
			: props.theme.primary.iconsColor
		};
	}

	& > img {
		max-height: 30px;
		max-width: 100%;
		min-width: 30px;
		margin: 0 10px;
	}
`;

const StyledBurgerButton = styled(StyledHeaderButton)`
	height: 25px;
	width: 25px;
`;

const TextButton = styled('div')`
	height: 30px;
	line-height: 30px;
	color: ${(props: StyledHeaderButtonProps) => props.isActive
		? props.theme.primary.actionColor
		: props.theme.primary.iconsColor
	};
	background-color: ${(props: StyledHeaderButtonProps) => props.theme.primary.topnavColor};
	margin: 0 5px;
	cursor: pointer;
`;

interface StyledCancelButtonProps extends BaseStyledComponentProps {
	isInTheater: boolean;
}

const StyledCancelButton = styled('div')`
	cursor: pointer;
	color: ${(props: StyledCancelButtonProps) => props.isInTheater ? StyleColor.White : props.theme.primary.actionColor };
	letter-spacing: 0.5px;
	text-decoration: none;
	font-size: 16px;
	font-weight: 500;
	padding: 6px 20px 0;
`;

export { StyledHeaderButton, TextButton, StyledCancelButton, StyledBurgerButton };


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/MenuManager/Header/HeaderButton/styles.ts